exports['arrow-down'] = require('./arrow-down')
exports['arrow'] = require('./arrow')
exports['campaign'] = require('./campaign')
exports['card'] = require('./card')
exports['check'] = require('./check')
exports['chevron-down'] = require('./chevron-down')
exports['chevron-left'] = require('./chevron-left')
exports['chevron-right'] = require('./chevron-right')
exports['chevron-up'] = require('./chevron-up')
exports['drag'] = require('./drag')
exports['filter'] = require('./filter')
exports['google'] = require('./google')
exports['graph'] = require('./graph')
exports['heart-filled'] = require('./heart-filled')
exports['heart'] = require('./heart')
exports['info'] = require('./info')
exports['link'] = require('./link')
exports['menu'] = require('./menu')
exports['more'] = require('./more')
exports['plus'] = require('./plus')
exports['receipt'] = require('./receipt')
exports['remove'] = require('./remove')
exports['stacked-menu'] = require('./stacked-menu')
exports['star-filled'] = require('./star-filled')
exports['star'] = require('./star')
exports['user'] = require('./user')
exports['x'] = require('./x')
exports['ALLOWED_ICONS'] = require('./ALLOWED_ICONS');
